import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'deposit-creditcard.component',
  templateUrl: '../sharedTemplates/deposit-creditcard.component.html',
})
export class DepositCreditCardComponent implements OnInit {
  creditcardDatas: UntypedFormGroup;
  creditcardDataRaw: any;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper
  ) {
    //  Validators.pattern(/^-?(0|[1-9]\d*)?$/)
    this.creditcardDatas = _FormBuilder.group({
      firstName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      lastName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      cardNumber: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(16)]),
      CCV: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      expDateMonth: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(2)]),
      expDateYear: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4)]),
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.creditcardDatas.statusChanges.subscribe(statusChanges => {
      // ////console.log("statusChanges", statusChanges);
    });

    this.creditcardDatas.valueChanges.subscribe(x => {
      // ////console.log("X", x);
      this.creditcardDataRaw = x;
    });
  }

  submitCreditCardData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositCreditCard(this.creditcardDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'errorcode1') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'approve') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.successSnackBar(t_message, '');

          this.creditcardDatas.disable();
        } else if (result.code == 'reject') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'pending') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.warningSnackBar(t_message, '');
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
